import React, { useState, useEffect } from "react";
import { useAppSelector } from "../../context-store";
import Layout from "../../components/layout/Layout";
import "../../assets/InnerCSS/plugins/bootstrap/css/bootstrap.min.css";
import "../../assets/InnerCSS/plugins/font-awesome/css/font-awesome.min.css";
import "../../assets/InnerCSS/plugins/icomoon/style.css";
import "../../assets/InnerCSS/plugins/uniform/css/default.css";
import "../../assets/InnerCSS/plugins/switchery/switchery.min.css";
import "../../assets/InnerCSS/plugins/nvd3/nv.d3.min.css";
import "../../assets/InnerCSS/css/styles.css";
import "../../assets/InnerCSS/css/custom.css";
import CandidateDashboardComponent from "../../components/candidate/dashboard/CandidateDashboardComponent";
import { CandidateDashboardModel } from "../../models/candidate/response/CandidateDashboardModel";
import CandidateService from '../../services/candidate/candidate-service';
import toasterUtils from "../../utils/toaster-utils";
import modalUtils from "../../utils/modal-utils";
import { useHistory } from "react-router";

const candidateDashboardRatingDefault = {
    interviewId: "",
    interviewUniqueId: "",
    ratingId: "",
    totalRating: "",
    interviewerComments: "",
    isCompanyInterview: false,
    candidateDashboardRatingDetails: [],
    softSkillRatingDetails: []
};

const candidateDashboardInterviewDefault = {
    candidateId: "",
    interviewId: "",
    interviewUniqueId: "",
    interviewDate: new Date(),
    interviewDateString: "",
    timeSlotName: "",
    primarySkillName: "",
    secondarySkillName: "",
    interviewerName: "",
    isRated: false,
    zoomMeetingUrl: ""
};

const candidateDashboardProfileDefault = {
    candidateId: "",
    candidateName: "",
    designationName: "",
    primarySkillName: "",
    cityName: "",
    experienceName: "",
    resumeTitle: ""
};

const candidateDashboardModelDefault: CandidateDashboardModel = {
    candidateDashboardProfile: candidateDashboardProfileDefault,
    candidateDashboardActiveInterview: candidateDashboardInterviewDefault,
    candidateDashboardCompletedInterview: candidateDashboardInterviewDefault,
    candidateDashboardRating: candidateDashboardRatingDefault
}

const CandidateDashboard = () => {
    const history = useHistory();
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const [candidateDashboardDetails, setCandidateDashboardDetails] = useState<CandidateDashboardModel>(candidateDashboardModelDefault);
    const [refreshCandidateDashboard, setRefreshCandidateDashboard] = useState<number>(2);

    useEffect(() => {
        if (loggedInUser) {
            getCandidateDashboardDetails(loggedInUser.profileId);
        }
    }, []);

    const getCandidateDashboardDetails = (candidateId?: string) => {
        if (candidateId) {
            modalUtils.showLoader();
            CandidateService.getCandidateDashboardDetails(candidateId).then((res) => {
                modalUtils.closeModal();
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                setCandidateDashboardDetails(res.data);
                setRefreshCandidateDashboard(refreshCandidateDashboard * 5);
            }).catch((error) => {
                modalUtils.closeModal();
                toasterUtils.showError(error);
            });
        }
    };

    return (
        <Layout>
            <div className="breadcrumb-text">
                <a onClick={() => history.push("/")}>Home</a> <i className="fa-solid fa-angle-right"></i> Dashboard
            </div>
            <div className="page-title">
                <h4 className="breadcrumb-header"> DASHBOARD</h4>
            </div>
            {refreshCandidateDashboard !== 2 &&
                <CandidateDashboardComponent
                    key={refreshCandidateDashboard}
                    objCandidateDashboardDetails={candidateDashboardDetails} />
            }
        </Layout>
    );
};
export default CandidateDashboard;